// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"da3afa14","192":"9099a5a4","384":"7d11984e"}[chunkId] + ".chunk.js";
};